import {createCssVar} from '../theme'

export const [scrollbarWidth, , scrollbarWidthToken] = createCssVar('scrollbar-width')
